import storage from 'redux-persist/lib/storage';
import { createTransform } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { IAuthStore } from './reducers/auth/types';

const persistedAuthKeys: Array<keyof IAuthStore> = [
	'savedUrl',
	'savedUrl2',
	'savedUrl3',
	'xMerchantId',
];

const pickPersistedAuthKeys = (state: Partial<IAuthStore>): Partial<IAuthStore> =>
	persistedAuthKeys.reduce<Partial<IAuthStore>>(
		(picked, key) => ({ ...picked, [key]: state?.[key] }),
		{},
	);

const authTransform = createTransform<IAuthStore, Partial<IAuthStore>>(
	(inboundState) => pickPersistedAuthKeys(inboundState),
	(outboundState) => pickPersistedAuthKeys(outboundState) as IAuthStore,
	{ whitelist: ['auth'] },
);

const persistConfig = {
	key: 'eas-cc-f',
	storage,
	transforms: [
		authTransform,
		encryptTransform({
			secretKey: 'rT2FZ5y9f9',
			onError: (error: Error) => {
				// eslint-disable-next-line no-console
				console.log(error);
			},
		}),
	],
	whitelist: ['auth'],
};
export { persistConfig };
